import { useCallback } from 'react';
import { pick, prop } from 'ramda';

import { setClientSkin } from 'js/app/hooks/auth/pas';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import * as helpers from '@core/js/hooks/auth/helpers';
import { useClientTypeAndPlatform } from '@interlayer/js/app/components/main/Registration/hooks/useClientTypeAndPlatform';

import * as pas from '../pas';

/** core, added setClientSkin, seon, clientPlatform, clientType */
export const useBeforeLoginAction = () => {
    const { deviceId, deliveryPlatform } = useDeviceSelector(pick(['deviceId', 'deliveryPlatform']));
    const clientSkin = useAppSelector(prop('clientSkin'));
    const { clientType, clientPlatform } = useClientTypeAndPlatform();

    return useCallback(() => {
        if (deviceId) {
            pas.setDeviceId(deviceId);
        }

        if (deliveryPlatform) {
            pas.setDeliveryPlatform(deliveryPlatform);
        }

        if (clientType) {
            pas.setClientType(clientType);
        }

        if (clientPlatform) {
            pas.setClientPlatform(clientPlatform);
        }

        const blackbox = helpers.getIovationBlackbox();

        if (blackbox) {
            pas.setIovationBlackbox(blackbox);
        }

        setClientSkin(clientSkin);
    }, [clientPlatform, clientSkin, clientType, deliveryPlatform, deviceId]);
};
